function getActionUrlForPriceFilter(button) {
    var action_url = button.parents('form').attr('action'),
        price_regex = /\/[\d_]{5,}-[\d_]{5,}/g,
        low_range_price_regex = /\/under-[\d_]{5,}/g,
        high_range_price_regex = /\/over-[\d_]{5,}/g,
        individual_price_regex = /\/[\d_]{5,}/g,
        params_regex = /\?.*$/g,
        price_url = '',
        low_price_url = '',
        high_price_url = '',
        individual_price_url = '',
        params_url = '';

    price_url = action_url.match(price_regex)
    low_price_url = action_url.match(low_range_price_regex);
    high_price_url = action_url.match(high_range_price_regex);
    individual_price_url = action_url.match(individual_price_regex);
    params_url = action_url.match(params_regex);

    if (price_url != '' && price_url != null) {
        action_url = action_url.replace(price_url, '');
    } else if (low_price_url != '' && low_price_url != null) {
        action_url = action_url.replace(low_price_url, '');
    } else if (high_price_url != '' && high_price_url != null) {
        action_url = action_url.replace(high_price_url, '');
    } else if (individual_price_url != '' && individual_price_url != null) {
        action_url = action_url.replace(individual_price_url, '');
    }

    if (params_url != '' && params_url != null) {
        action_url = action_url.replace(params_url, '');
    }

    return [action_url, params_url];
}

export {getActionUrlForPriceFilter}